module.exports = __webpack_public_path__ + "img/icon_yinshuiji_02.ef6d5d4b.png";